module.exports = __webpack_public_path__ + "static/tophat-fc65be3abb974a8893318b0a7810c494.png";